import React from "react";
import { TableCell, TableRow } from "../../../design/table";
import { FinancialAccount } from "../../../models/FinancialAccount";

interface Props {
  financialAccount: FinancialAccount;
}

const FinancialAccountListItem: React.FC<Props> = ({ financialAccount }) => {
  return (
    <TableRow
      key={financialAccount._id}
      href={`/financial-account/${financialAccount._id}`}
      className="transition-colors cursor-pointer hover:bg-gray-100"
    >
      <TableCell className="w-1/4">{financialAccount.name}</TableCell>
      <TableCell className="w-1/4">{financialAccount.type}</TableCell>
      <TableCell className="w-1/4">{financialAccount.mask}</TableCell>
      <TableCell className="w-1/4 text-right">
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: financialAccount.currency,
        }).format(financialAccount.currentBalance)}
      </TableCell>
    </TableRow>
  );
};

export default FinancialAccountListItem;
